import { Close } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import classes from './base-dialog.module.scss';

/**
 * @author IKlapouch
 * @date 13/07/2023
 * @description ET:44 - Dialog layout improvements
 **/

export const BaseDialog = ({ open, onClose, maxWidth, fullWidth, onKeyPress, title, content, actions, noButtonStyle, ...args }) => {

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            onKeyPress={onKeyPress}
            className={classes.baseDialog}
            disableEnforceFocus
            {...args}
        >

            <BaseDialogTitle onClose={onClose} />

            <DialogContent className={classes.baseDialogContent}>
                {title && (<div className={classes.baseDialogContentTitle}>{title}</div>)}

                <div>{content}</div>

                {actions && (<div className={classes.baseDialogContentDivider} />)}
            </DialogContent>

            <DialogActions className={!noButtonStyle ? classes.baseDialogActions : ''}>
                {actions}
            </DialogActions>

        </Dialog>
    );
};

const BaseDialogTitle = (props) => {
    return (
        <DialogTitle className={classes.baseDialogTitle} style={{backgroundColor: "black"}}>
            <IconButton onClick={props.onClose}>
                <Close />
            </IconButton>
        </DialogTitle>
    );
};
